import { useMemo } from 'react';
import { Contact } from '@/types/crm';
import { calculateLeadScore } from '@/lib/leadAnalysis';

export function useLeadScore(lead: Contact) {
  return useMemo(() => calculateLeadScore(lead), [lead]);
}
